export default "__VITE_ASSET__GBlkUfQ2__"